import Vue from "vue";
import Vuex from 'vuex';
import C from './constant';
import i18n from '../i18n'

Vue.use(Vuex);

const FILTER_NONE = {
  site_type: '', // O: new open, G: general
  room_num: '', // '': all, 0:1, 1:1.5, 2: 2, 3: 3, 4: 4
  maemul_type: '',
  toilet_num: '', // 1, 2, 3
  elevator: '', // Y, N
  duplex: '', // Y, N
  teras: '',               // Y, N
  show_site_inquire_only: 'N',               // Y, N
  not_show_site_inquire: 'N',               // Y, N
  trans_type: '', // T, C, I, M
  sale_price_min: 0,
  sale_price_max: 1000, // 1000 = 1 billion = 1000 * 1 million
  charter_price_min: 0,
  charter_price_max: 1000,
  safe_charter: 'N', // Y, N
  smb: 'N', // Y, N
  invest_price_min: 0,
  invest_price_max: 100,
  monthly_rent_deposit_min: 0,
  monthly_rent_deposit_max: 200,
  monthly_rent_min: 0,
  monthly_rent_max: 200,
  area_type: '', // E, R
  exclusive_area_min: 0,
  exclusive_area_max: 50,
  real_area_min: 0,
  real_area_max: 50,
  fee_type: '', // T, C, O, S
  fee_trading_min: 0,
  fee_trading_max: 100,
  fee_charter_min: 0,
  fee_charter_max: 100,
  fee_invest_min: 0,
  fee_invest_max: 100,
  fee_monthly_min: 0,
  fee_monthly_max: 100,
  period_type: '', // R, O
  reg_date_start: 0,
  reg_date_end: 24,
  open_date_type: -1, // All
  open_date_start: 0,
  open_date_end: 50,
  lat: 0,
  lng: 0,
  radius: 0.3,
  keyword: '',
  zoom_level: 5,
  minLat: 0,
  minLng: 0,
  maxLat: 0,
  maxLng: 0
};

export default new Vuex.Store({
  state: {
    loading: false,
    me: null,
    accessToken: '',
    tabIndex: C.MAIN_TAB.HOME,
    admTabIndex: -1,
    adminLock:true,
    is_Admin_mode: false,

    logout_need: false,
    notifyTabIndex: C.NOTIFY_TAB.MODIFY,
    lastTabIndex: C.MAIN_TAB.HOME,
    adminTabIndex: C.ADMIN.TAB.MEMBER,
    is_copy_notification: false,
    is_today_notify_list: false,
    site_idx_for_notify_list: null,
    is_auto_notification: false,
    modify_notification_idx: null,
    auto_notification_info: {},
    auto_notification_title: null,
    is_auto_page: false,
    forceHideMainBottomBar: false,
    is_unregistered_site: false,

    isLoading: false,
    isLoadingText: '',

    logOutNeed: false,
    tmpTabIndex: null,
    goSale:true,

    filter: {
      site_type: '', // O: new open, G: general
      maemul_type: '',
      room_num: '', // '': all, 0:1, 1:1.5, 2: 2, 3: 3, 4: 4
      toilet_num: '', // 1, 2, 3
      elevator: '', // Y, N
      duplex: '', // Y, N
      teras: '',               // Y, N
      show_site_inquire_only: 'N',               // Y, N
      not_show_site_inquire: 'N',               // Y, N
      trans_type: '', // T, C, I, M
      sale_price_min: 0,
      sale_price_max: 1000, // 1000 = 1 billion = 1000 * 1 million
      charter_price_min: 0,
      charter_price_max: 1000,
      safe_charter: 'N', // Y, N
      smb: 'N', // Y, N
      invest_price_min: 0,
      invest_price_max: 100,
      monthly_rent_deposit_min: 0,
      monthly_rent_deposit_max: 200,
      monthly_rent_min: 0,
      monthly_rent_max: 200,
      area_type: '', // E, R
      exclusive_area_min: 0,
      exclusive_area_max: 50,
      real_area_min: 0,
      real_area_max: 50,
      fee_type: '', // T, C, O, S
      fee_trading_min: 0,
      fee_trading_max: 100,
      fee_charter_min: 0,
      fee_charter_max: 100,
      fee_invest_min: 0,
      fee_invest_max: 100,
      fee_monthly_min: 0,
      fee_monthly_max: 100,
      period_type: '', // R, O
      reg_date_start: 0,
      reg_date_end: 24,
      open_date_type: -1, // All
      open_date_start: 0,
      open_date_end: 50,
      lat: 0,
      lng: 0,
      radius: 0.3,
      keyword: '',
      zoom_level: 5,
      minLat: 0,
      minLng: 0,
      maxLat: 0,
      maxLng: 0
    },

    filterBackup: {
      site_type: '', // O: new open, G: general
      maemul_type: '',
      room_num: '', // '': all, 0:1, 1:1.5, 2: 2, 3: 3, 4: 4
      toilet_num: '', // 1, 2, 3
      elevator: '', // Y, N
      duplex: '', // Y, N
      teras: '',               // Y, N
      show_site_inquire_only: 'N',               // Y, N
      not_show_site_inquire: 'N',               // Y, N
      trans_type: '', // T, C, I, M
      sale_price_min: 0,
      sale_price_max: 1000, // 1000 = 1 billion = 1000 * 1 million
      charter_price_min: 0,
      charter_price_max: 1000,
      safe_charter: 'N', // Y, N
      smb: 'N', // Y, N
      invest_price_min: 0,
      invest_price_max: 100,
      monthly_rent_deposit_min: 0,
      monthly_rent_deposit_max: 200,
      monthly_rent_min: 0,
      monthly_rent_max: 200,
      area_type: '', // E, R
      exclusive_area_min: 0,
      exclusive_area_max: 50,
      real_area_min: 0,
      real_area_max: 50,
      fee_type: '', // T, C, O, S
      fee_trading_min: 0,
      fee_trading_max: 100,
      fee_charter_min: 0,
      fee_charter_max: 100,
      fee_invest_min: 0,
      fee_invest_max: 100,
      fee_monthly_min: 0,
      fee_monthly_max: 100,
      period_type: '', // R, O
      reg_date_start: 0,
      reg_date_end: 24,
      open_date_type: -1, // All
      open_date_start: 0,
      open_date_end: 50,
      lat: 0,
      lng: 0,
      radius: 0.3,
      keyword: '',
      zoom_level: 5,
      minLat: 0,
      minLng: 0,
      maxLat: 0,
      maxLng: 0
    },
    fcItems: [
      [{
          ic_active: require('../assets/image/ic_subway_on@2x.png'),
          ic_inactive: require('../assets/image/ic_subway@2x.png'),
          text: i18n.t('map.subway_sta'),
          active: false,
          idx : 1,
        },
        {
          ic_active: require('../assets/image/ic_bus_on@2x.png'),
          ic_inactive: require('../assets/image/ic_bus@2x.png'),
          text: i18n.t('map.bus_sta'),
          active: false,
          idx : 3,
        },
        {
          ic_active: require('../assets/image/ic_mart_on@2x.png'),
          ic_inactive: require('../assets/image/ic_mart@2x.png'),
          text: i18n.t('map.mart'),
          active: false,
          idx : 5,
        },
        {
          ic_active: require('../assets/image/ic_convience_on@2x.png'),
          ic_inactive: require('../assets/image/ic_convience@2x.png'),
          text: i18n.t('map.convenience'),
          active: false,
          idx : 7,
        },

        {
          ic_active: require('../assets/image/ic_drugstore_on@2x.png'),
          ic_inactive: require('../assets/image/ic_drugstore@2x.png'),
          text: i18n.t('map.drug_store'),
          active: false,
          idx : 11,
        },
        {
          ic_active: require('../assets/image/ic_park_on@2x.png'),
          ic_inactive: require('../assets/image/ic_park@2x.png'),
          text: i18n.t('map.park'),
          active: false,
          idx : 13,
        },
      ],
      [{
          ic_active: require('../assets/image/ic_childcenter_on@2x.png'),
          ic_inactive: require('../assets/image/ic_childcenter@2x.png'),
          text: i18n.t('map.child_center'),
          active: false,
          idx : 15,
        },
        {
          ic_active: require('../assets/image/ic_kindgarden_on@2x.png'),
          ic_inactive: require('../assets/image/ic_kindgarden@2x.png'),
          text: i18n.t('map.kindergarden'),
          active: false,
          idx : 17,
        },
        {
          ic_active: require('../assets/image/ic_elementary_on@2x.png'),
          ic_inactive: require('../assets/image/ic_elementary@2x.png'),
          text: i18n.t('map.elementary_sc'),
          active: false,
          idx : 19,
        },
        {
          ic_active: require('../assets/image/ic_middle_on@2x.png'),
          ic_inactive: require('../assets/image/ic_middle@2x.png'),
          text: i18n.t('map.middle_sc'),
          active: false,
          idx : 21,
        },
        {
          ic_active: require('../assets/image/ic_high_on@2x.png'),
          ic_inactive: require('../assets/image/ic_high@2x.png'),
          text: i18n.t('map.high_sc'),
          active: false,
          idx : 23,
        },
      ],
    ],
  },
  getters: {
    isLoading: state => state.loading,
    accessToken: state => state.accessToken,
    tabIndex: state => state.tabIndex,
    goSale: state => state.goSale,
    admTabIndex: state => state.admTabIndex,
    adminLock: state => state.adminLock,
    deviceId: state => state.deviceId,
    fcmToken: state => state.fcmToken,
    myInfo: state => state.me,
    filter: state => state.filter,
    fcItems: state => state.fcItems,
    getForceHideMainBottomBar : state => state.forceHideMainBottomBar,
    getCopyNotification : state => state.is_copy_notification,
    getAutoNotification : state => state.is_auto_notification,
    getAutoNotificationInfo : state => state.auto_notification_info,
    getAutoNotificationTitle : state => state.auto_notification_title,
    getIsAutoPage : state => state.is_auto_page,
    getTodayNotifyList : state => state.is_today_notify_list,
    getSiteForNotifyList : state => state.site_idx_for_notify_list,
    getNotifyTabIndex : state => state.notifyTabIndex,
    getLogOutNeed : state => state.logOutNeed,
    getTmpTabIndex : state => state.tmpTabIndex,
    getAdminMode : state => state.is_Admin_mode,
    getModifyNotification : state => state.modify_notification_idx,
    getUnregisteredSite : state => state.is_unregistered_site,

  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setLoadingText: (state, text) => state.isLoadingText = text,
    setAccessToken: (state, token) => state.accessToken = token,
    setTabIndex: (state, idx) => state.tabIndex = idx,
    setGoSale: (state, idx) => state.goSale = idx,
    setDeviceId: (state, uid) => state.deviceId = uid,
    setFcmToken: (state, token) => state.fcmToken = token,
    setAdmTabIndex: (state, idx) => state.admTabIndex = idx,
    setAdmLock: (state, idx) => state.adminLock = idx,
    setCopyNotification: (state, isSet) => state.is_copy_notification = isSet,
    setAutoNotification: (state, isSet) => state.is_auto_notification = isSet,
    setTodayNotifyList: (state, isSet) => state.is_today_notify_list = isSet,
    setSiteForNotifyList: (state, index) => state.site_idx_for_notify_list = index,
    setNotifyTabIndex: (state, index) => state.notifyTabIndex = index,
    setAutoNotificationInfo: (state, info) => state.auto_notification_info = info,
    setAutoNotificationTitle: (state, title) => state.auto_notification_title = title,
    setIsAutoPage: (state, flag) => state.is_auto_page = flag,
    setLogOutNeed: (state, flag) => state.logOutNeed = flag,
    setForceHideMainBottomBar: (state, isHide) => state.forceHideMainBottomBar = isHide,
    setTmpTabIndex: (state, index) => state.tmpTabIndex = index,
    setModifyNotification: (state, index) => state.modify_notification_idx = index,
    setUnregisteredSite: (state, flag) => state.is_unregistered_site = flag,
    setAdminMode: (state, flag) => state.is_Admin_mode = flag,
    setMyInfo: (state, val) => {
      state.me = Object.assign(state.me, val);
    },
    transMyInfo: (state, result) => {
      let authorityList = result.f_admin_authority.split(',');
      let realAuthorityList = [];
      for (let i = 0; i < authorityList.length; i++) {
        if (authorityList[i] === '' || authorityList[i] == null) {
          continue;
        }
        realAuthorityList.push(parseInt(authorityList[i]));
      }

      let info = {
        uid: result.f_idx,
        type: result.f_type,
        phone: result.f_phone,
        businessCard: result.f_business_card,
        affiliation: result.f_affiliation,
        name: result.f_name,
        point: result.f_point,
        push: result.f_push,
        pushVibration: result.f_push_vibration,
        pushStartTime: result.f_push_off_start_time,
        pushEndTime: result.f_push_off_end_time,
        longitude: 0,
        latitude: 0,
        usageDate: result.f_usage_date,
        madeCnt: result.f_made_count,
        pushCnt: result.f_push_count,
        admin_authority: realAuthorityList,
      };
      state.admTabIndex = (realAuthorityList.length > 0 ? realAuthorityList[0] : -1);
      state.me = info;
    },
    setFilter: (state, filter) => {
      state.filter = Object.assign(state.filter, filter);
      //state.filterBackup = Object.assign(state.filterBackup, filter);
    },
    setBackupFilter: (state) => {
      state.filterBackup = Object.assign({}, state.filter);
    },
    setRestoreFilter: (state) => {
      state.filter = state.filterBackup;
    },
    initFilter: (state) => {
      state.filter = Object.assign({}, FILTER_NONE);
    },
    setFcItemActive: (state,v) => state.fcItems[v.i][v.j].active = v.v,
  },
  actions: {

  },
});



// WEBPACK FOOTER //
// ./src/config/store.js